import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InspectionEquipmentService } from '../../../service/inspection-equipment/inspection-equipment.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteInspectionEquipmentComponent),
  multi: true,
};

@Component({
  selector: 'app-autocomplete-inspection-equipment',
  templateUrl: './autocomplete-inspection-equipment.component.html',
  styleUrls: ['./autocomplete-inspection-equipment.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class AutocompleteInspectionEquipmentComponent implements ControlValueAccessor, OnInit {
    @Input() inspectionEquipmentId: number;
    @Output() onMyChange = new EventEmitter();
    @Input() disabled: boolean;
    @Input() damageable: boolean;
    @Input() stealable: boolean;
    
    @ViewChild('input') textarea;

    public inspectionEquipmentsOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    public sel: any;

    public modViewInformationInspectionEquipmentDialog: boolean;

    constructor(
        private renderer: Renderer2,
        public inspectionEquipmentService: InspectionEquipmentService
    ) {
        this.page = 1;
        this.per_page = 10;
        this.modViewInformationInspectionEquipmentDialog = false;
    }

    public ngOnInit() {
        this.query = undefined;
        this.filters = [];
        // this.filters.push({key: 'activated-lk', value: '1'});
        if (this.inspectionEquipmentId) {
            this.filters.push({key: 'id-lk', value: String(this.inspectionEquipmentId)});
        }
        if (this.damageable) {
            this.filters.push({key: 'damageable-in', value: '1'});
        }
        if (this.stealable) {
            this.filters.push({key: 'stealable-in', value: '1'});
        }
        this.getInspectionEquipments(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onMyChange.emit(this.sel);
        this.onChange(this.sel);
        this.onTouched(this.sel);
    }

    public loadInspectionEquipmentsLazy(event) {
        this.getInspectionEquipments(event.query);
    }

    getInspectionEquipments(query?: string, filters?: any[]) {
        this.inspectionEquipmentService.getInspectionEquipment(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                this.inspectionEquipmentsOptions = response.json().data;
                if (this.inspectionEquipmentId) {
                    this.inspectionEquipmentId = undefined;
                    this.sel = this.inspectionEquipmentsOptions[0];
                    this.filters = [];
                    this.filters.push({key: 'activated-lk', value: '1'});
                    if (this.inspectionEquipmentId) {
                        this.filters.push({key: 'id-lk', value: String(this.inspectionEquipmentId)});
                    }
                }

                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                // this.inspectionEquipmentsOptions = [];
                // inspectionEquipments.forEach(element => {
                //     if (this.inspectionEquipmentId === element.id) {
                //         this.inspectionEquipmentsOptions.push({id: element.id, name: element.name, selected: true, company: element.company});
                //     } else {
                //         this.inspectionEquipmentsOptions.push({id: element.id, name: element.name, selected: false, company: element.company});
                //     }
                // });
            },
            error => {
                this.inspectionEquipmentsOptions = [];
                this.inspectionEquipmentsOptions.push({id: '', name: 'Error'});
            }
        );
    }

    public showInformationInspectionEquipmentDialog() {
        this.modViewInformationInspectionEquipmentDialog = true;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/inspection-equipments/autocomplete-inspection-equipment/autocomplete-inspection-equipment.component.ts